export default {"src":"/_next/static/media/icon_nav_dd_store_data_off.1ca6e43b.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};